(function () {
  'use strict';

  function initFlorettiScrollVideos(root) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(pointer: coarse), (max-width: 749px)');
    var videos = (root || document).querySelectorAll('[data-video] video');
    if (!videos.length) return;

    videos.forEach(function (video) {
      video.controls = false;
      // Geen autoplay: dat forceert direct downloaden ondanks preload="none"
      // en concurreert met de hero (LCP). play() start pas als hij in beeld is.
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.defaultMuted = true;
      video.muted = true;
      video.loop = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      if (mobile.matches) video.preload = 'metadata';
      if (reducedMotion.matches || video.dataset.florettiScrollVideoReady === 'true') return;
      video.dataset.florettiScrollVideoReady = 'true';

      function playInline() {
        var result = video.play();
        if (result && typeof result.catch === 'function') {
          result.catch(function () {
            if (mobile.matches) video.controls = true;
          });
        }
      }

      if (!('IntersectionObserver' in window)) {
        video.preload = 'auto';
        playInline();
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (video.preload !== 'auto') video.preload = 'auto';
              playInline();
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(video);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFlorettiScrollVideos(document);
  });
})();
